export default {
  namespaced: true,
  state: {
    dataList: [
      // {
      //   title: "资源名称",
      //   text: "稳定、安全、弹性、高性能的云端计算服务，实时满足您需求，稳定、安全、弹性、高性能的云端计算服务是的哇、圣诞袜圣诞袜。",
      // },
    ]
  }
}
